const shell = {
  collapsible: {
    showLess: 'Minder tonen',
    showMore: 'Ontdek wat dit inhoudt →',
  },

  error: {
    eyebrow: 'Er ging iets mis',
    titleLead: 'Even pauze.',
    titleAccent: 'We pakken het op.',
    body: 'Een onderdeel van de app reageerde niet zoals verwacht. Je antwoorden tot nu toe zijn lokaal bewaard — laad de pagina opnieuw om verder te gaan. Lukt het daarna nog niet, dan help ik graag persoonlijk.',
    reload: 'Pagina opnieuw laden',
    mailLink: 'Stuur Judith een bericht →',
    mailSubject: 'Foutmelding TOF Persona',
  },
};

export default shell;
